export enum ELang {
  'italiano' = 'it',
  'english' = 'en'
}
